// Five primary services with sub-practices, structured for clear on-page sectioning.
// Fractional HR services and HR Tech Consulting live under HR Consulting.

export const SERVICES_LIST = [
  {
    id: "recruitment",
    number: "01",
    title: "Recruitment",
    tagline: "Talent, delivered — IT and non-IT.",
    lead:
      "End-to-end hiring for IT and non-IT companies — from executive search to specialist roles across the org. One shortlist, senior judgment, faster close.",
    subServices: [
      {
        name: "IT & Non-IT hiring",
        blurb:
          "Product, engineering, data, sales, operations — permanent and contract, across seniority.",
      },
      {
        name: "Executive & leadership search",
        blurb:
          "CxO and functional-head mandates run with confidentiality and calibration you can defend to a board.",
      },
    ],
    image:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  },
  {
    id: "hr-consulting",
    number: "02",
    title: "HR Consulting",
    tagline: "Org design, comp and culture — architected.",
    lead:
      "Strategy work for founders and boards — org design, workforce planning, compensation architecture and engagement programs, all mapped to your 12-month plan. Includes fractional HR services when you need senior HR judgment on a part-time footing.",
    subServices: [
      {
        name: "Fractional HR services",
        blurb:
          "Senior HR judgment on a fractional footing — advisory, embedded, or interim — for founders and boards who need HR leadership without the year-round overhead.",
      },
      {
        name: "HR strategy & org design",
        blurb:
          "Structure, span-of-control, workforce planning and a talent operating model you can execute.",
      },
      {
        name: "Benefits & compensation",
        blurb:
          "Market-benchmarked salary bands, job evaluation, ESOP & LTI design — defensible and transparent.",
      },
      {
        name: "Employee engagement",
        blurb:
          "Listening systems, recognition, DEI and manager enablement — programs wired to outcomes.",
      },
      {
        name: "Talent operating model",
        blurb:
          "Roles, rituals and decision rights for people work across product, engineering and go-to-market.",
      },
      {
        name: "HR Tech Consulting",
        blurb:
          "HRMS and engagement-tool advisory — vendor evaluation, configuration, data migration and implementation support, through to adoption and admin training.",
      },
    ],
    image:
      "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  },
  {
    id: "hr-operations",
    number: "03",
    title: "HR Operations",
    tagline: "The plumbing behind great people work.",
    lead:
      "Policies, processes, HRMS and day-to-day HR operations built to scale — from first-hire to 500+ headcount without breaking, and audit-ready across jurisdictions.",
    subServices: [
      {
        name: "Policy & handbook design",
        blurb:
          "Handbooks that reflect your culture and hold up in review — leaves, POSH, remote, IP, code of conduct.",
      },
      {
        name: "HRMS selection & rollout",
        blurb:
          "Vendor selection, data migration, workflow design and change management for a system that sticks.",
      },
      {
        name: "Payroll & compliance",
        blurb:
          "Statutory, PF/ESI, tax, cross-border payroll and audit calendars — the plumbing done right.",
      },
      {
        name: "Employee lifecycle SOPs",
        blurb:
          "Onboarding, confirmation, transfers, exits — documented, automated where possible, humane where it matters.",
      },
    ],
    image:
      "https://images.unsplash.com/photo-1497215842964-222b430dc094?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  },
  {
    id: "employer-branding",
    number: "04",
    title: "Employer Branding",
    tagline: "Be the offer candidates chase.",
    lead:
      "Employer brand strategy, creative and content — delivered with trusted partners — so the best candidates say yes before you make the offer.",
    subServices: [
      {
        name: "EVP research & articulation",
        blurb:
          "What you promise to talent, backed by evidence — interviews, sensing and market signal.",
      },
      {
        name: "Careers site & content",
        blurb:
          "A careers hub that converts, with story-driven content and role-page templates that recruiters love.",
      },
      {
        name: "Social & recruiter enablement",
        blurb:
          "LinkedIn, video and outreach assets — plus training so recruiters carry the brand end-to-end.",
      },
      {
        name: "Awards & recognition",
        blurb:
          "Great Place to Work, LinkedIn Top Companies, industry lists — nominated, submitted, won.",
      },
    ],
    image:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  },
  {
    id: "gcc-support",
    number: "05",
    title: "GCC Support",
    tagline: "Your Global Capability Centre — built right.",
    lead:
      "End-to-end HR support for Global Capability Centres — standing up the people function for your new entity: HR setup, recruitment, policy and process benchmarking, and alignment with global HQ standards.",
    subServices: [
      {
        name: "HR setup & entity readiness",
        blurb:
          "Offer letters, statutory registrations, onboarding infrastructure, HR calendar and compliance wiring for the new entity.",
      },
      {
        name: "Recruitment & talent pipeline",
        blurb:
          "Founding-team search through scaled hiring — sourcing engines, interview design and offer management tuned to the GCC charter.",
      },
      {
        name: "Policy & process benchmarking",
        blurb:
          "Leave, compensation, travel, data and conduct policies benchmarked against global HQ standards and local market norms.",
      },
      {
        name: "Global alignment & governance",
        blurb:
          "Reporting cadence, HRBP alignment, culture integration and governance rituals that keep the GCC in step with HQ.",
      },
    ],
    image:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  },
];

export const INDUSTRIES = [
  "Global Capability Centres",
  "AI-Native IT Services",
  "SaaS & Product",
  "Analytics & Technology",
  "Global IT Services",
  "BPO / ITES",
];

export const REGIONS = [
  "United States",
  "United Kingdom",
  "Canada",
  "India",
  "Poland",
  "Spain",
  "Ukraine",
];

export const STATS = [
  { value: "14+", label: "Years HR Leadership" },
  { value: "20+", label: "Countries Supported" },
  { value: "1500+", label: "Employees Supported" },
  { value: "5", label: "Primary Practices" },
];
